export default "__VITE_ASSET__ClhMWmN6__"